import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HeaderItemModel } from '../model/header-item.model';

@Injectable()
export class HeaderItemService {

    path = '/header-item';

    constructor(private baseService: BaseService) {}

    findByChecklistId(checklistId: number) {
        return this.baseService.get(this.path, '/by-checklist/' + checklistId);
    }

    save(headerItem: HeaderItemModel) {
        if (headerItem.id) { return this.put(headerItem); } else { return this.post(headerItem); }
    }

    post(headerItem: HeaderItemModel) {
        return this.baseService.post(this.path, '/', headerItem);
    }

    put(headerItem: HeaderItemModel) {
        return this.baseService.put(this.path, '/', headerItem);
    }

    delete(id: number) {
        return this.baseService.delete(this.path, '/' + id);
    }

    saveInChecklist(headerItem: HeaderItemModel[], checklist_id) {
        return this.baseService.post(this.path, '/in-checklist/' + checklist_id, headerItem);
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/header-item.service.ts